import { useCallback, useEffect, useState } from "react";
import { useLocale, useService } from "../../../../hooks";

export const useChatBot = () => {
  const { t } = useLocale();
  const { fetchAll, save } = useService("Data", "chat");
  const { operateMessage, generateUID, showAlert } = useService("Misc");
  const [chatData, setchatData] = useState([]);
  const [genericMessages, setgenericMessages] = useState([]);
  const [queries, setqueries] = useState([]);
  const [activeQuery, setactiveQuery] = useState<string>("");

  const chatbotToggle = () => {
    document.getElementById("chatbot").classList.toggle("active");
  };

  const scrolltoBottom = () => {
    let chatBox = document.getElementsByClassName("chatbot-wrapper")[0];
    setTimeout(() => {
      chatBox.scrollTop = chatBox.scrollHeight;
    }, 1000);
  };

  const addMsg = useCallback(
    (msg) => {
      chatData.push(msg);
      setchatData(chatData);
      scrolltoBottom();
    },
    [chatData]
  );

  const getChatsData = useCallback(async () => {
    const result = await fetchAll();
    if (result.status) {
      if (result.data?.length !== 0) {
        let chatList = [],
          queries = [];
        result.data.forEach((e) => {
          if (e.type === "generic") chatList.push(e);
          else if (e.type === "queries") queries.push(e);
        });
        setgenericMessages(chatList);
        setqueries(queries);
      }
    } else addMsg({ msg: t("errorMsg.fail.serverConnection"), msgType: "bot" });
  }, [addMsg, fetchAll, t, setgenericMessages, setqueries]);

  const saveQuery = useCallback(
    async (q) => {
      let chatObject = {
          question: q,
          answer: "",
          type: "queries",
          uid: generateUID(),
        },
        error = false;
      if (q === "") {
        error = true;
      }
      if (!error) {
        const result = await save(chatObject);
        if (result.status) {
          showAlert({
            type: "success",
            msg: t("success.chatbotQuerySubmitted"),
          });
          addMsg({ msg: t("success.chatbotQuerySubmitted"), msgType: "bot" });
          getChatsData();
        }
      }
    },
    [addMsg, generateUID, getChatsData, save, showAlert, t]
  );

  const ansQuery = useCallback(
    (q) => {
      let msgFound;
      genericMessages.forEach((e) => {
        if (operateMessage(q) === operateMessage(e.question)) {
          if (e.answer !== "") {
            addMsg({
              msg: e.answer,
              msgType: "bot",
            });
          }
          msgFound = true;
        }
      });
      if (!msgFound) {
        queries.forEach((e) => {
          if (operateMessage(q) === operateMessage(e.question)) {
            addMsg({ msg: e.answer, msgType: "bot" });
            msgFound = true;
          }
        });
      }
      if (!msgFound) saveQuery(q);
    },
    [addMsg, genericMessages, operateMessage, queries, saveQuery]
  );

  const askQuery = useCallback(
    (e) => {
      e.preventDefault();
      addMsg({
        msg: activeQuery,
        msgType: "mine",
      });
      ansQuery(activeQuery);
      setchatData(chatData);
      setactiveQuery("");
    },
    [activeQuery, addMsg, ansQuery, chatData, setchatData, setactiveQuery]
  );

  const inputQuery = (e) => setactiveQuery(e.target.value);

  useEffect(() => {
    if (queries.length === 0 || genericMessages.length === 0) getChatsData();
  }, [getChatsData, queries, genericMessages]);

  return {
    inputQuery,
    chatbotToggle,
    chatData,
    askQuery,
    activeQuery,
  };
};
